import datapoints from '../datapoints';
import setInboxRuleRequestStatus from './helpers/setGetInboxRuleRequestStatus';
import getInboxRulesService from '../services/getInboxRulesService';
import InboxRuleRequestStatus from '../store/schema/InboxRuleRequestStatus';
import InboxRuleRowType from '../store/schema/InboxRuleRowType';
import { InboxRulesListOptionState } from '../store/schema/InboxRulesListOptionState';
import store from '../store/store';
import { ObservableMap } from 'mobx';
import { logUsage } from 'owa-analytics';
import { DatapointStatus, returnTopExecutingActionDatapoint } from 'owa-analytics';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import InboxRule from 'owa-service/lib/contract/InboxRule';
import { action, select } from 'satcheljs/lib/legacy';

export interface GetInboxRuleOptionState {
    optionState: InboxRulesListOptionState;
}

/**
 * Gets inbox rules and stores them in the inboxRules options store
 */
export default select<GetInboxRuleOptionState>({
    optionState: () => store.inboxRulesListState,
})(
    action('getInboxRules', datapoints.getInboxRulesDatapoint)(function getInboxRules(
        state?: GetInboxRuleOptionState
    ) {
        let { optionState } = state;
        setInboxRuleRequestStatus(InboxRuleRequestStatus.Pending);
        optionState.inboxRuleIds = [];
        optionState.inboxRules = new ObservableMap();
        let dataPoint = returnTopExecutingActionDatapoint();

        return getInboxRulesService()
            .then(response => {
                if (response.WasSuccessful) {
                    setInboxRuleRequestStatus(InboxRuleRequestStatus.Complete);
                    let inboxRuleCollection = response.InboxRuleCollection.InboxRules;
                    const {
                        name: eventName,
                        customData: customData,
                    } = datapoints.numInboxRules.datapoint;
                    logUsage(eventName, customData(inboxRuleCollection.length));

                    for (let inboxRule of inboxRuleCollection) {
                        addInboxRuleToStore(inboxRule, optionState);
                        if (!optionState.hasLoggedGetInboxRulesInformation) {
                            const {
                                name: eventName,
                                customData: customData,
                            } = datapoints.getInboxRuleDatapoint.datapoint;
                            logUsage(eventName, customData(inboxRule));
                        }
                    }
                    optionState.hasLoggedGetInboxRulesInformation = true;
                } else {
                    let errorMessage = response.ErrorMessage
                        ? response.ErrorMessage
                        : 'Response WasSuccessful was false';
                    setInboxRuleRequestStatus(InboxRuleRequestStatus.Error);
                    dataPoint.endWithError(DatapointStatus.ServerError, new Error(errorMessage));
                }
            })
            .catch(error => {
                setInboxRuleRequestStatus(InboxRuleRequestStatus.Error);
                dataPoint.endWithError(DatapointStatus.ServerError, error.message);
            });
    })
);

let addInboxRuleToStore = action('addInboxRuleToStore')(function addInboxRuleToStore(
    inboxRule: InboxRule,
    optionState: InboxRulesListOptionState
) {
    const ruleId = inboxRule.Identity.RawIdentity;
    optionState.inboxRuleIds.push(ruleId);
    // transform inbox rule to InboxRuleRowType and add to map
    optionState.inboxRules.set(ruleId, {
        ...inboxRule,
        drop: {
            isDragOver: false,
            draggableItemType: DraggableItemTypes.InboxRule,
        },
    } as InboxRuleRowType);
});
